import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { jobsStateForIdSelector, jobSelector } from '../../reducers/job-selectors';
import { shouldStatusExecute } from '../../reducers/utils/state-manager';

import * as Api from '../../api/api';

import { LOAD_JOBS_API_VERSION } from './load-org-jobs';

export const loadJob = (jobId: number) =>
  createGenericDispatcher({
    name: 'LOAD_JOB',
    loadFunction: () => Api.get(`/jobs?jobId=${jobId}&version=${LOAD_JOBS_API_VERSION}`),
    args: { jobId },
    shouldExecute: (state: any) => {
      const status = jobsStateForIdSelector(state, jobId);
      const job = jobSelector(state, jobId);
      return shouldStatusExecute(status, Boolean(job));
    },
  });
